module.exports = {"blocks":[{"type":"sections/sg/faq","prefix":"faq"}]}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/sg/setting/faq/setting.json
// module id = 702
// module chunks = 0 1 2 3 4 5